// extracted by mini-css-extract-plugin
module.exports = {"help":"Help_help__t1Fo7","icon":"Help_icon__ARrb3","label":"Help_label__SoBYq","rotation":"Help_rotation__EEoSd"};